import { Base } from '../../abstract/base.model';
import { isRecord } from '../utils/is-record';
import { listOf, nullableNumber, nullableString } from '../utils/wire-value-utils';
import { toTestQuestionOption } from '../utils/safety-test-wire-utils';
import { QuestionType } from './question-type.model';
import { TestQuestionOption } from './test-question-option.model';

/**
 * A safety-test question. The hub sends two shapes: the test detail (`GET /admin/safety-tests/:id`) sends
 * `text` / `type` with `options`, while question create / update return the hub model (`questionText` /
 * `questionType`, no options). Both are read; a field the hub didn't send stays `undefined`.
 */
export class TestQuestion extends Base {
  // Writable via PUT /admin/safety-tests/:id/questions/:qId (the hub's TEST_QUESTION_WRITABLE)
  text?: string | null;
  explanation?: string | null;
  type?: QuestionType | null;

  // Read-only
  testId?: string | null;
  sortOrder?: number | null;
  /** Empty when the hub sent none (create / update responses). */
  options: TestQuestionOption[];

  constructor(data: unknown) {
    super(data);
    const source = isRecord(data) ? data : {};
    this.text = nullableString(source['text'] ?? source['questionText']);
    this.explanation = nullableString(source['explanation']);
    this.type = nullableString(source['type'] ?? source['questionType']) as QuestionType | null | undefined;
    this.testId = nullableString(source['testId']);
    this.sortOrder = nullableNumber(source['sortOrder']);
    this.options = listOf(source['options'], toTestQuestionOption);
  }
}
